import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles({
  categoriesSection: {
    marginTop: 16
  },
  excludeCategoriesTitle: {
    marginTop: 16
  }
})

export default useStyles
